// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/chats/components/chatitem/index.scss
// module id = 2371
// module chunks = 13